import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

import Top from '../navigation/top';
import { FormRow } from '../form/formField';

const initialState = {};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    email: { label: 'email', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    bounceQty: { label: 'bounceQty', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    bounces: { label: 'bounces', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },
    complaintQty: { label: 'complaintQty', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    complaints: { label: 'complaints', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },
    lastBounceDate: { label: 'lastBounceDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class MailaddressEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { mailaddressStore } = this.props.stores;
        mailaddressStore.load(props.id);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'email', 'bounceQty', 'bounces', 'complaintQty', 'complaints', 'lastBounceDate', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
        ];
    }

    updateField = async (id, field, value) => {
        const { mailaddressStore } = this.props.stores;
        mailaddressStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { mailaddressStore } = this.props.stores;
        await mailaddressStore.saveField(id, field, value);
    }

    render(props) {
        const { mailaddressStore } = this.props.stores;
        const { mailaddress, saved } = mailaddressStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/mailaddresses' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {mailaddress.email}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/mailaddresss/${props.mailaddressid}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={mailaddress}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default MailaddressEdit;



// WEBPACK FOOTER //
// ./components/mailaddresses/edit.js